import type { CaptureProgress, ResponseDetail, ResponseList } from "@crux/contracts";
import type { paths } from "../api-types.js";
import { api } from "../client.js";
import { problem } from "./errors.js";

/**
 * Stored answers, and how far today's capture has got.
 */

export type ResponseQuery = NonNullable<
  paths["/api/workspaces/{workspaceId}/responses"]["get"]["parameters"]["query"]
>;

export async function fetchResponses(
  workspaceId: string,
  query: ResponseQuery,
): Promise<ResponseList> {
  const { data, response } = await api.GET("/api/workspaces/{workspaceId}/responses", {
    params: { path: { workspaceId }, query },
  });
  if (data === undefined) {
    throw new Error(problem(response.status, "load these captures"));
  }
  return data;
}

export async function fetchResponseDetail(
  workspaceId: string,
  runId: string,
): Promise<ResponseDetail> {
  const { data, response } = await api.GET(
    "/api/workspaces/{workspaceId}/responses/{runId}",
    { params: { path: { workspaceId, runId } } },
  );
  if (data === undefined) {
    throw new Error(problem(response.status, "open this capture"));
  }
  return data;
}

export function responsesCsvHref(workspaceId: string, search: string): string {
  const query = search === "" ? "" : `?${search}`;
  return `/api/workspaces/${encodeURIComponent(workspaceId)}/responses.csv${query}`;
}

export async function fetchCaptureProgress(
  workspaceId: string,
  reportId: string,
): Promise<CaptureProgress> {
  const { data, response } = await api.GET(
    "/api/workspaces/{workspaceId}/reports/{reportId}/capture-progress",
    { params: { path: { workspaceId, reportId } } },
  );
  if (data === undefined) {
    throw new Error(problem(response.status, "check on this report's captures"));
  }
  return data;
}
